import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    DownloadApiRes,
    IDownloadApiRes as TDownloadApiRes,
} from "../../types/attachments/downloadApiRes"
import {
    ILargeAttachmentRes,
    LargeAttachmentRes,
} from "../../types/attachments/largeAttachmentRes"

type TAttachmentMapper = {
    map: (response: unknown) => TDownloadApiRes
}

export const attachmentMapper: TAttachmentMapper = {
    /** Maps the response from the API to the IDownloadApiRes type */
    map: (response: unknown): TDownloadApiRes =>
        tsIoValidate(DownloadApiRes, response, "Error mapping attachment"),
}

type TLargeAttachmentMapper = {
    map: (response: unknown) => ILargeAttachmentRes
}

export const largeAttachmentMapper: TLargeAttachmentMapper = {
    /** Maps the response from the API to the ILargeAttachmentRes type */
    map: (response: unknown): ILargeAttachmentRes =>
        tsIoValidate(
            LargeAttachmentRes,
            response,
            "Error mapping large attachment"
        ),
}
